import { render, staticRenderFns } from "./OrderSales.vue?vue&type=template&id=6a2b8560&scoped=true&"
import script from "./OrderSales.vue?vue&type=script&lang=js&"
export * from "./OrderSales.vue?vue&type=script&lang=js&"
import style0 from "./OrderSales.vue?vue&type=style&index=0&id=6a2b8560&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b8560",
  null
  
)

export default component.exports